// extracted by mini-css-extract-plugin
module.exports = {"findWord":"FindWord-module_findWord_2DKHX","findWord__wrapper":"FindWord-module_findWord__wrapper_2IoAa"};